import React, { useContext, useState } from "react";
import { useHistory } from "react-router";
import { PermissionContext, RolePermissions } from "appContext";

import { ReactComponent as DocumentIcon } from "assets/img/svg/Document.svg";
import { ReactComponent as ExcellIcon } from "assets/img/svg/excel.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard";
import DownloadReports from "./DownloadReports";
import { pages } from "views/pages/manage/common/constant";

const ModuleCards = ({}) => {
  const history = useHistory();

  const ManageReceiptPermission = RolePermissions(
    useContext(PermissionContext),
    pages["paymentCollectionManageReceipts"]["id"]
  );

  const DCRPermission = RolePermissions(
    useContext(PermissionContext),
    pages["paymentCollectionDownloadReports"]["id"]
  );

  const EPMRPermission = RolePermissions(
    useContext(PermissionContext),
    pages["epmrListing"]["id"]
  );

  const BulkCollPermission = RolePermissions(
    useContext(PermissionContext),
    pages["paymentCollectionBulk"]["id"]
  );

  const [isOpenReportDialog, setIsOpenReportDialog] = useState(false);

  const cards = [
    ...(ManageReceiptPermission.length
      ? [
          {
            heading: "Manage receipt",
            subHeading:
              "Print all Single or Bulk receipts, resend receipt notifications, view Acknowledgement IDs.",
            icon: <DocumentIcon />,
            action: () => {
              history.push("/admin/paymentCollection/manageReceipts");
            },
          },
        ]
      : []),
      ...(BulkCollPermission.length
        ? [
            {
              heading: "Bulk Collection",
              subHeading:
                "Generate receipts in bulk",
              icon: <DocumentIcon />,
              action: () => {
                history.push("/admin/paymentCollection/bulkCollection");
              },
            },
          ]
        : []),
    ...(DCRPermission.length
      ? [
          {
            heading: "Download reports",
            subHeading: "Ageing report, Current stock availability etc.",
            icon: <ExcellIcon />,
            action: () => {
              setIsOpenReportDialog(true);
            },
          },
        ]
      : []),

    ...(EPMRPermission.length
      ? [
          {
            heading: "Manage EPMR",
            subHeading: "View all EPMR receipts",
            icon: <DocumentIcon />,
            action: () => {
              history.push("/admin/paymentCollection/manageEpmr");
            },
          },
        ]
      : []),
  ];
  return (
    <>
      <div className={`screen-cards-container`}>{getScreenCards(cards)}</div>

      {isOpenReportDialog && (
        <DownloadReports
          open={isOpenReportDialog}
          setOpen={setIsOpenReportDialog}
        />
      )}
    </>
  );
};

export default ModuleCards;
